import React, { useState } from 'react';

const CardTodaysPromo = ({ img, alt, productName, qty, discount, discountPrice, actualPrice }) => {
  const [isQtyLow, setIsQtyLow] = useState(() => qty < 6);
  const currencyFormat = number => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(number)

  return (
    <div className='card-todays-promo'>
      <div className="img-wrapper">
        <div className="discount">{discount} OFF</div>
        <img src={img} alt={alt} />
      </div>
      <div className="card-desc">
        <div className="product-name">{productName}</div>
        <div className="qty-left"><span style={isQtyLow ? { color: '#FF0000' } : { color: '#026BB9' }}>{qty}</span> Produk Tersisa</div>
        <div className="discount-price">{currencyFormat(discountPrice)}</div>
        <div className="actual-price">{currencyFormat(actualPrice)}</div>
      </div>
    </div>
  )
}

export default CardTodaysPromo
